// Вторият ред под името на реда в листа „Изписване" — общ за решетката и
// картите: при продукт наличността КЪМ ДАТАТА („Наличност: 0,500 кг", а когато
// продуктът не стига и се иска и от други редове — „· нужни общо 1,200 кг"), при
// рецепта — колко цели порции стигат („Стига за: 5 порции").
import { useTranslation } from "react-i18next";
import { formatQty } from "../../components/qty";
import { portionsLabel } from "./writeoffConfirms";
import type { RecipeRowStock } from "./useWriteoffStock";
import type { StockShortage } from "./writeoffStockCheck";
import type { WriteoffLineDraft } from "./writeoffWorksheetShared";

export function ProductAvailabilityText({
  line,
  available,
  decimals,
  unit,
  shortage,
}: {
  line: WriteoffLineDraft;
  available: number | null; // null — зарежда се
  decimals: number;
  unit: string | null;
  shortage: StockShortage | undefined;
}) {
  const { t } = useTranslation();
  const unitSuffix = unit ? ` ${unit}` : "";
  const sharedNeed =
    shortage && shortage.sources.some((source) => source.lineKey !== line.key) ? shortage.needed : null;
  return (
    <>
      {t("inventoryPage.colAvailable")}: {available == null ? "…" : formatQty(Math.max(0, available), decimals)}
      {unitSuffix}
      {sharedNeed != null &&
        ` · ${t("inventoryPage.wr6NeededTotal", { value: `${formatQty(sharedNeed, decimals)}${unitSuffix}` })}`}
    </>
  );
}

// „Стига за: 5 порции" · „Стига за: …" (зарежда се) · „Рецептата няма съставки"
export function RecipeFitsText({ stock }: { stock: RecipeRowStock | undefined }) {
  const { t } = useTranslation();
  if (stock?.empty) return <>{t("inventoryPage.recipeEmpty")}</>;
  const fits = stock?.fittingPortions;
  return (
    <>
      {t("inventoryPage.wr6FitsLabel")}: {fits == null ? "…" : portionsLabel(t, fits)}
    </>
  );
}
